module.exports = __webpack_public_path__ + "img/logo-prisma-horizontal.b267b697.svg";